<!--
 * @Author: zjw
 * @Date: 2021-05-26 10:03:52
 * @LastEditTime: 2023-05-18 15:31:25
 * @FilePath: \web-app\src\components\content\myPagination.vue
 * @Environment: Vue + Element
 * @Description: 分页组件
-->
<template>
  <div class="pagination">
    <el-pagination
      class="page-box"
      background
      layout="total, sizes, prev, pager, next, jumper"
      :current-page="initData.childMsg.currentPage"
      :page-sizes="[10, 15, 20, 50, 100]"
      :page-size="initData.childMsg.pageSize"
      :total="initData.childMsg.total"
      v-bind="$attrs"
      v-on="$listeners"
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
    >
    </el-pagination>
  </div>
</template>
<script>
export default {
  name: "myPagination",
  props: ["isPageShow"], //是否显示分页组件
  inheritAttrs: false, //默认为true
  data() {
    return {
      initData: {},
      timer: null,
    };
  },
  created() {
    this.initData = this.$attrs;
    const timer = setInterval(() => {
      // 某些定时器操作
    }, 500);
    //内部监听生命周期函数并做相应操作 $on/$once
    this.$once("hook:beforeDestroy", () => {
      clearInterval(timer);
    });
  },
  methods: {
    handleSizeChange(val) {
      this.initData.childMsg.pageSize = val;
      this.$listeners.callFather(this.initData.childMsg);
      // this.$emit("callFather", this.initData.childMsg);
    },
    handleCurrentChange(val) {
      this.initData.childMsg.currentPage = val;
      this.$listeners.callFather(this.initData.childMsg);
      this.$bus.$emit("clearActive");
    },
    //在组件内部监听生命周期函数
    clickFun() {
      // console.log('beforeDestroy');
    },
  },
};
</script>

<style>
.page-box {
  margin: 10px auto;
}
.pagination {
  /* padding: 10px; */
  text-align: right;
  /* background-color: #ffffff; */
}
/* .el-pager li:last-child{
    display:none;
} */
</style>
